export const customObjectsUserRelationshipTypeSchema = "/data_objects/user_relationship_type_schema" as const;
